
import About from "./pages/About/About";
import Home from "./pages/Home";
import { Route, Routes } from "react-router-dom";
import Contact from "./pages/Contact";
import Services from "./pages/Services/Services";
import MoneyOnMind from "./pages/Resources/CaseStudies/MoneyOnMind";
import WebDesign from "./pages/Services/WebDesign"
import Blog from "./pages/Resources/Blog/Blog"
import CEOGlowUp from "./pages/Services/CEOGlowUp"
import LaunchGlowUp from "./pages/Services/LaunchGlowUp"
import TheBusinessGlowUp from "./pages/Services/TheBusinessGlowUp"
import Blog2Signs from "./pages/Resources/Blog/Blog2Signs";
import Lubbock from "./pages/SEO Pages/Lubbock";
import SanAntonio from "./pages/SEO Pages/SanAntonio";
import Houston from "./pages/SEO Pages/Houston";
import FortWorth from "./pages/SEO Pages/FortWorth";
import Dallas from "./pages/SEO Pages/Dallas";
import Austin from "./pages/SEO Pages/Austin";
import TemplateShop from "./pages/TemplateShop"
import ClientWork from "./pages/Resources/CaseStudies/ClientWork";
import Mobeaulity from "./pages/Resources/CaseStudies/Mobeaulity";
import Nouriv from "./pages/Nouriv"
import BookingApp from "./pages/BookingApp";
import WaitlistApp from "./pages/WaitlistApp";
import Prebuilt from "./pages/Prebuilt";
import BraidersLandPage from "./pages/Braiders/BraidersLandPage";
import BaltimoreBraiderPage from "./pages/Braiders/BraidersSEOPages/BaltimoreBraiderPage";
import AugustaBraiderPage from "./pages/Braiders/BraidersSEOPages/AugustaBraiderPage";
import NewOrleansBraiderPage from "./pages/Braiders/BraidersSEOPages/NewOrleansBraiderPage";
import MaconBraiderPage from "./pages/Braiders/BraidersSEOPages/MaconBraiderPage";
import BatonRougeBraiderPage from "./pages/Braiders/BraidersSEOPages/BatonRougeBraiderPage";
import ShreveportBraiderPage from "./pages/Braiders/BraidersSEOPages/ShreveportBraiderPage";
import AtlantaBraiderPage from "./pages/Braiders/BraidersSEOPages/AtlantaBraiderPage";
import HoustonBraiderPage from "./pages/Braiders/BraidersSEOPages/HoustonBraiderPage";
import AustinBraiderPage from "./pages/Braiders/BraidersSEOPages/AustinBraiderPage";
import DallasBraiderPage from "./pages/Braiders/BraidersSEOPages/DallasBraiderPage";
import NewYorkCityBraiderPage from "./pages/Braiders/BraidersSEOPages/NewYorkCityBraiderPage";
import WashingtonDCBraiderPage from "./pages/Braiders/BraidersSEOPages/WashingtonDCBraiderPage";
import PhiladelphiaBraiderPage from "./pages/Braiders/BraidersSEOPages/PhiladelphiaBraiderPage";

function App() {
  return (
    <div>
      <Routes>
      {/* Main pages */}
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} /> 
        <Route path="/services" element={<Services />} />
        <Route path="/clientwork" element={<ClientWork />} />
        <Route path="/webdesign" element={<WebDesign />} />
        <Route path="/templateshop" element={<TemplateShop />} /> 
        <Route path="/web-design-seo-women-entrepreneurs-austin" element={<Austin />} />
        <Route path="/dallas-female-founder-website-design" element={<Dallas />} />
        <Route path="/web-design-seo-women-entrepreneurs-fortworth" element={<FortWorth />} />
        <Route path="/houston-female-founder-website-design" element={<Houston />} />
        <Route path="/web-design-seo-women-entrepreneurs-sanantonio" element={<SanAntonio />} />
        <Route path="/lubbock-female-founder-website-design" element={<Lubbock />} />
       
       
       
        {/* Packages pages */}
        <Route path="/ceoglowup" element={<CEOGlowUp />} />
        <Route path="/launchglowup" element={<LaunchGlowUp />} />
        <Route path="/businessglowup" element={<TheBusinessGlowUp />} />

        {/* Packages pages Braiders */}
        <Route path="/braiderswebsites" element={<BraidersLandPage />} /> 
         <Route path="/baltimorebraiderwebsites" element={<BaltimoreBraiderPage />} /> 
         <Route path="/augustabraiderwebsites" element={<AugustaBraiderPage/>} /> 
         <Route path="/neworleansbraiderwebsites" element={<NewOrleansBraiderPage/>} />
          <Route path="/maconbraiderwebsites" element={<MaconBraiderPage/>} />
          <Route path="/braiderwebsites" element={<BatonRougeBraiderPage/>} />
          <Route path="/shreveportbraiderwebsites" element={<ShreveportBraiderPage/>} />
          <Route path="/atlantabraiderwebsites" element={<AtlantaBraiderPage/>} />
          <Route path="/houstonbraiderwebsites" element={<HoustonBraiderPage/>} />
          <Route path="/austinbraiderwebsites" element={<AustinBraiderPage/>} />
          <Route path="/dallasbraiderwebsites" element={<DallasBraiderPage/>} />
          <Route path="/newyorkcitybraiderwebsites" element={<NewYorkCityBraiderPage/>} />
          <Route path="/washingtondcbraiderwebsites" element={<WashingtonDCBraiderPage/>} />
          <Route path="/philadelphiabraiderwebsites" element={<PhiladelphiaBraiderPage/>} />
          <Route path="/braiderwebsites" element={<NewOrleansBraiderPage/>} />


        {/* Blog pages */}
        <Route path="/blog" element={<Blog />} />
        <Route path="/websiteredesignsigns" element={<Blog2Signs />} />

         {/* Client Work pages */}
        <Route path="/moneyOnMind" element={<MoneyOnMind />} />
        <Route path="/mobeaulity" element={<Mobeaulity />} /> 
        

          {/* Template pages */}
          <Route path="/nouriv" element={<Nouriv />} /> 
          <Route path="/bookingapp" element={<BookingApp />} />
          <Route path="/waitlistapp" element={<WaitlistApp />} /> 

          


          <Route path="/prebuilttemplates" element={<Prebuilt />} />

        </Routes>
        </div>
  )
}

export default App;
